import React from "react";
import { Link } from "react-router-dom";
import { Cancel, Href, PrintInvoice } from "../../../../../utils/Constant";
import { InvoicePrintType } from "../../../../../Type/Application/Ecommerce/Ecommerce";

export const InvoiceButtons: React.FC<InvoicePrintType> = ({ handlePrint }) => {

  return (
    <span className="pb-5" style={{ display: "flex", justifyContent: "center", gap: 15, }}>
      <Link onClick={handlePrint} className="btn btn-primary" style={{ borderRadius: 10, padding: "18px 27px", fontSize: 16, fontWeight: 600, outline: 0, border: 0, textDecoration: "none", }} to={Href}>
        Impprimer
        <i className="fa fa-print" style={{ fontSize: 13, fontWeight: "bold", marginLeft: 10 }} />
      </Link>
      <Link className="btn btn-light-primary" style={{ borderRadius: 10, padding: "18px 27px", fontSize: 16, fontWeight: 600, outline: 0, border: 0, textDecoration: "none", }} to={`${process.env.PUBLIC_URL}/ventes-historique`} download>
        {Cancel}
      </Link>
    </span>
  );
};